module.exports = __webpack_public_path__ + "img/20048.35da3824.png";